import { QuickPay } from '@/components/PaymentButtons/QuickPay';
import * as Styled from './BasketExpressCheckout.styled';

export const BasketExpressCheckout = () => (
  <Styled.Container>
    <Styled.OrDivider>
      <Styled.DividerLine />
      <Styled.OrText>or</Styled.OrText>
      <Styled.DividerLine />
    </Styled.OrDivider>
    <QuickPay />
  </Styled.Container>
);